import styled from 'styled-components';
import { AccordionDetails } from '@interstate/components/AccordionGroup';
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const EmployeeInputGroup = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1.5rem;
    row-gap: 0.5rem;
    margin-top: 1rem;
`;

export const EmployeeButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 1rem;
    gap: 1rem;
    justify-content: flex-end;
`;

export const EmployeeFieldRow = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 0.875rem;
    row-gap: 0.5rem;
    margin-top: 0.5rem;
    align-items: end;

    @media (max-width: ${BreakPoint.PHONE}) {
        grid-template-columns: 1fr 1fr;
        row-gap: 1rem;
    }
`;

export const RoleHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const RoleBlock = styled.div`
    margin-top: 1rem;

    &:first-of-type {
        margin-top: 3rem;
    }
`;

export const SlideOutIntroText = styled.p`
    margin: 1rem 0 1.5rem;

    & + ${RoleBlock}:first-of-type {
        margin-top: 0;
    }
`;

export const AdditionalRolesContainer = styled.div`
    margin-top: 0;
`;

export const AdditionalRolesTopDivider = styled.hr`
    margin: 1.5rem 0 0.5rem;
`;

export const AdditionalRolesCountBadge = styled.span`
    flex-shrink: 0;
    padding: 0.125rem 0.5rem;
    border-radius: 0.75rem;
    background-color: ${({ theme }) => theme.tokens.BaseColorGray100};
    color: ${({ theme }) => theme.tokens.BaseColorGray700};
    white-space: nowrap;

    /* Doubled class (0,2,0) so the size is not outranked by a vendor rule like
       '.ids-SlideOut-content span' (0,1,1), which a single class ties one point below. */
    && {
        font-size: 14px;
    }
`;

export const AdditionalRolesDescription = styled.p`
    margin: 0.5rem 0 1.125rem;
    font-size: 16px;

    & + ${RoleBlock}:first-of-type {
        margin-top: 0;
    }
`;

export const AdditionalRolesBody = styled(AccordionDetails)`
    ${RoleBlock}:last-of-type > hr {
        display: none;
    }
`;

export const SlideOutPanelBody = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const SlideOutScrollableContent = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 0 6px;
    margin: 0 -6px;
`;

export const SlideOutPinnedFooter = styled.div`
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    margin: 0 -24px -32px -24px;
    padding: 20px 24px;
    border-top: 1px solid ${({ theme }) => theme.tokens.SemColorBorderMuted};
    background-color: ${({ theme }) => theme.tokens.SemColorOverlaySubdued};
`;
